export default function newsletter() {
	const newsletter = document.getElementById('newsletterForm');
	if (newsletter) {
		newsletter.addEventListener('submit', function (event) {
			event.preventDefault(); // Prevent the form from submitting immediately
			// find input and retrieve the value
			const email = document.querySelector('.newsletter__email');
			if (email) {
				const emailValue = email.value;
				// add email into the url to be retrieved by tess-additions js when user goes to tess
				const url = `https://my.pem.org/account/create/brief?email=${emailValue}`;
				// Open the URL in a new tab
				window.open(url, '_blank');
			}
		});
	}
}
